import type { UserProfile } from '@/interfaces/user';
import type { AuthState as UserAuthState } from '@/interfaces/user/auth';

export type { UserAuthState };

export interface ExtendedAuthState extends UserAuthState {
  currentUser?: UserProfile;
  refreshToken?: string;
}

export const initialAuthState: ExtendedAuthState = {
  isAuthenticated: false,
  isLoading: false,
  token: undefined,
  refreshToken: undefined,
  error: undefined,
  currentUser: undefined,
};
